<div class="root">
  <div class="button-file" [ngClass]="classes" [ngbTooltip]="buttonTooltip">
    <my-global-icon *ngIf="icon" [iconName]="icon"></my-global-icon>

    <span>{{ inputLabel }}</span>

    <input
      type="file"
      [name]="inputName" [id]="inputName" [accept]="extensions"
      (change)="fileChange($event)" [(ngModel)]="fileInputValue"
    />
  </div>

  <div class="filename" *ngIf="displayFilename === true && filename">{{ filename }}</div>

  <button *ngIf="displayReset && filename" i18n class="reset-button reset-button-small ms-2" (click)="reset()">
    Reset
  </button>
</div>
